function e(a) {
  var s = a.id, n = a.images;
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' + // Each sheet has at most one "drawing", so a globally-unique drawing ID is assumed to be the sheet ID.
  (n ? '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="../drawings/drawing'.concat(s, '.xml"/>') : "") + "</Relationships>";
}
export {
  e as default
};
//# sourceMappingURL=index.es431.js.map
